export enum FolderItemType {
  email = 'email',
  'email-asset' = 'email-asset',
  'email-template' = 'email-template',
  sms = 'sms',
  form = 'form',
  ma = 'ma',
  website = 'website',
  topic = 'topic',
}
